import Image from "next/image";

interface LogosProps {
  tagline?: string;
  bgColor?: string;
}

const Logos = ({ tagline, bgColor = "#F5F5F5" }: LogosProps) => {
  const displayTagline = tagline || "Recognized for home buying excellence";

  return (
    <section
      id="logos"
      style={{
        backgroundColor: bgColor,
      }}
    >
      <div className="m-auto max-w-[1180px] px-6 py-5 ">
        <div className="flex flex-col items-center justify-center @3xl:flex-row">
          <div className=""></div>
          <div className="">
            <p className="visible mx-auto text-center text-base  leading-5 text-primary-700 md:hidden  ">
              {displayTagline}
            </p>
            <section
              className="max-w-[1180px]"
              style={{
                display: "flex",
                height: "100%",
                maxHeight: "100%",
                placeItems: "center",
                margin: "0px",
                padding: "10px",
                listStyleType: "none",
                opacity: "1",

                overflow: "hidden",
              }}
            >
              <p className="hidden max-w-[175px] text-center text-base leading-5 text-primary-700 [text-wrap:balance] sm:mx-auto  sm:max-w-[250px] md:block md:max-w-[230px] md:text-left md:leading-snug lg:max-w-none ">
                {displayTagline}
              </p>
              <div
                className="overflow-hidden"
                style={{
                  display: "flex",
                  height: "100%",
                  maxHeight: "100%",
                  placeItems: "center",
                  margin: "0px",
                  padding: "10px",
                  listStyleType: "none",
                  opacity: "1",
                  WebkitMaskImage:
                    "linear-gradient(to right, rgba(0, 0, 0, 0) 0%, rgb(0, 0, 0) 12.5%, rgb(0, 0, 0) 87.5%, rgba(0, 0, 0, 0) 100%)",
                  overflow: "hidden",
                }}
              >
                <div className="img-ticker-logos -mx-4 flex">
                  <Image
                    priority={true}
                    width={80}
                    height={42}
                    alt=""
                    className="mx-2 h-[42px] w-[80px] flex-none self-start @2xl:mx-6"
                    src="/travel_and_leisure.png"
                  />
                  <Image
                    priority={true}
                    width={80}
                    height={42}
                    alt=""
                    className="mx-2 h-[42px] w-[80px] flex-none self-start @2xl:mx-6"
                    src="/houzz.svg"
                  />
                  <Image
                    priority={true}
                    width={80}
                    height={42}
                    alt=""
                    className="mx-2 h-[42px] w-[80px] flex-none self-start @2xl:mx-6"
                    src="/la_times.png"
                  />
                  <Image
                    priority={true}
                    width={80}
                    height={42}
                    alt=""
                    className="mx-2 h-[42px] w-[80px] flex-none self-start @2xl:mx-6"
                    src="/architectural_digest.svg"
                  />
                  <Image
                    priority={true}
                    width={80}
                    height={42}
                    alt=""
                    className="mx-2 h-[42px] w-[80px] flex-none self-start @2xl:mx-6"
                    src="/the_spruce.svg"
                  />
                  <Image
                    priority={true}
                    width={80}
                    height={42}
                    alt=""
                    className="mx-2 h-[42px] w-[80px] flex-none self-start @2xl:mx-6"
                    src="/elle-decor.svg"
                  />
                  <Image
                    priority={true}
                    width={80}
                    height={42}
                    alt=""
                    className="mx-2 h-[42px] w-[80px] flex-none self-start @2xl:mx-6"
                    src="/travel_and_leisure.png"
                  />
                  <Image
                    priority={true}
                    width={80}
                    height={42}
                    alt=""
                    className="mx-2 h-[42px] w-[80px] flex-none self-start @2xl:mx-6"
                    src="/houzz.svg"
                  />
                  <Image
                    priority={true}
                    width={80}
                    height={42}
                    alt=""
                    className="mx-2 h-[42px] w-[80px] flex-none self-start @2xl:mx-6"
                    src="/la_times.png"
                  />
                  <Image
                    priority={true}
                    width={80}
                    height={42}
                    alt=""
                    className="mx-2 h-[42px] w-[80px] flex-none self-start @2xl:mx-6"
                    src="/architectural_digest.svg"
                  />
                  <Image
                    priority={true}
                    width={80}
                    height={42}
                    alt=""
                    className="mx-2 h-[42px] w-[80px] flex-none self-start @2xl:mx-6"
                    src="/the_spruce.svg"
                  />
                  <Image
                    priority={true}
                    width={80}
                    height={42}
                    alt=""
                    className="mx-2 h-[42px] w-[80px] flex-none self-start @2xl:mx-6"
                    src="/elle-decor.svg"
                  />
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Logos;
